
<div class="relative">
  <app-button 
    #legendBtn
    [type]="type"
    [custom]="['dark-button']"
    class="opacity-0"
    (event)="toggleContainer()"
  >
      <svg ngProjectAs="icon" class="text-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.842 13.999">
          <g id="Icon_ion-help-outline" data-name="Icon ion-help-outline" transform="translate(-10.468 -5.155)">
              <path id="Trazado_104" data-name="Trazado 104" d="M11.25,8.952a3.387,3.387,0,0,1,1.277-2.264A3.733,3.733,0,0,1,14.9,5.906a4.131,4.131,0,0,1,1.731.3A3.069,3.069,0,0,1,18.56,8.952c0,1.739-1.111,2.527-2.374,3.4a3.025,3.025,0,0,0-1.586,2.7" transform="translate(0 0)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/>
              <path id="Trazado_105" data-name="Trazado 105" d="M17.624,27.093a1.218,1.218,0,1,1-1.218-1.218A1.218,1.218,0,0,1,17.624,27.093Z" transform="translate(-1.806 -9.157)" fill="currentColor"/>
          </g>
      </svg>
  </app-button>

  <div #legendContent role="region" [attr.aria-label]="translation.getText('legend', 'help', 'Help')" class="legend-panel absolute right-0 top-12 z-20 hidden w-[min(360px,calc(100vw-32px))] max-h-[calc(100dvh-120px)] flex-col gap-2 overflow-hidden text-sm leading-normal text-white opacity-0 pointer-events-none not-[.hidden]:flex">
    <section class="legend-card flex min-h-0 flex-col overflow-hidden rounded-lg bg-[rgb(12_12_20/94%)] p-5 backdrop-blur-[8px]">
      <h2 class="m-0 mb-4 shrink-0 text-xs leading-normal font-medium tracking-[.04em] text-[#a1a1aa] uppercase">{{ translation.getText('legend', 'controls_title', 'Controls') }}</h2>
      <div class="legend-scroll scrollbar min-h-0 overflow-y-auto overscroll-contain pr-2 [scrollbar-gutter:stable]" tabindex="0" role="region" [attr.aria-label]="translation.getText('legend', 'controls_title', 'Controls')">
        <ul class="m-0 flex list-none flex-col gap-3.5 p-0 [&>li]:grid [&>li]:grid-cols-[52px_minmax(0,1fr)] [&>li]:items-center [&>li]:gap-3 [&>li]:wrap-anywhere">
          @for (control of controls; track control.key) {
            <li>
              <span class="flex items-center justify-center gap-1.5 [&>svg]:h-6.5 [&>svg]:w-5.5" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" [class.rotate-90]="control.key === 'search'">
                  <path [attr.d]="control.path" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              <span>{{ translation.getText('legend', control.key, control.text) }}</span>
            </li>
          }
          <li>
            <span class="flex items-center justify-center gap-1.5 [&>svg]:h-6.5 [&>svg]:w-4.5" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 4.5v15m7.5-7.5h-15" stroke-linecap="round" /></svg>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14" stroke-linecap="round" /></svg>
            </span>
            <span>{{ translation.getText('legend', 'zoom', 'Zoom in or out') }}</span>
          </li>
        </ul>
      </div>
    </section>

    <section class="legend-card flex min-h-0 flex-col overflow-hidden rounded-lg bg-[rgb(12_12_20/94%)] p-5 backdrop-blur-[8px]">
      <h2 class="m-0 mb-4 shrink-0 text-xs leading-normal font-medium tracking-[.04em] text-[#a1a1aa] uppercase">{{ translation.getText('legend', 'navigation_title', 'Navigation') }}</h2>
      <div class="legend-scroll scrollbar min-h-0 overflow-y-auto overscroll-contain pr-2 [scrollbar-gutter:stable]" tabindex="0" role="region" [attr.aria-label]="translation.getText('legend', 'navigation_title', 'Navigation')">
        <ul class="m-0 flex list-none flex-col gap-3.5 p-0 [&>li]:grid [&>li]:grid-cols-[52px_minmax(0,1fr)] [&>li]:items-center [&>li]:gap-3 [&>li]:wrap-anywhere">
          <li>
            <span class="flex items-center justify-center gap-1.5 [&>svg]:h-6.5 [&>svg]:w-5.5" aria-hidden="true">
              <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="7" y="2" width="18" height="28" rx="9" />
                <path d="M16 3v12H8V11a8 8 0 0 1 8-8Z" fill="currentColor" stroke="none" />
              </svg>
            </span>
            <span>{{ translation.getText('legend', 'mouse_select', 'Left click to select') }}</span>
          </li>
          <li>
            <span class="flex items-center justify-center gap-1.5 [&>svg]:h-6.5 [&>svg]:w-5.5" aria-hidden="true">
              <svg viewBox="0 0 40 32" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="11" y="2" width="18" height="28" rx="9" /><path d="m6 11-4 5 4 5m28-10 4 5-4 5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span>{{ translation.getText('legend', 'mouse_pan', 'Drag to move around the map') }}</span>
          </li>
          <li>
            <span class="flex items-center justify-center gap-1.5 [&>svg]:h-6.5 [&>svg]:w-5.5" aria-hidden="true">
              <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="7" y="2" width="18" height="28" rx="9" /><path d="M16 7v7" stroke-width="3" stroke-linecap="round" />
              </svg>
            </span>
            <span>{{ translation.getText('legend', 'mouse_zoom', 'Scroll to zoom in or out') }}</span>
          </li>
        </ul>
        <div class="mt-5 border-t border-white/15 pt-5 [&_kbd]:inline-flex [&_kbd]:h-6 [&_kbd]:w-5.5 [&_kbd]:items-center [&_kbd]:justify-center [&_kbd]:rounded-[5px] [&_kbd]:border [&_kbd]:border-[#85858f] [&_kbd]:[font-family:inherit] [&_kbd]:[font-size:inherit] [&_kbd]:leading-none">
          <ul class="m-0 flex list-none flex-col gap-3.5 p-0 [&>li]:grid [&>li]:grid-cols-[72px_minmax(0,1fr)] [&>li]:items-center [&>li]:gap-3 [&>li]:wrap-anywhere">
            <li>
              <span class="flex flex-col items-center justify-center gap-0.75 [&>span]:flex [&>span]:items-center [&>span]:justify-center [&>span]:gap-0.75" aria-hidden="true"><kbd>↑</kbd><span><kbd>←</kbd><kbd>↓</kbd><kbd>→</kbd></span></span>
              <span>{{ translation.getText('legend', 'keyboard_pan', 'Arrow keys to move around the map') }}</span>
            </li>
            <li>
              <span class="flex items-center justify-center gap-0.75" aria-hidden="true"><kbd>+</kbd><kbd>−</kbd></span>
              <span>{{ translation.getText('legend', 'keyboard_zoom', '+ / − keys to zoom in or out') }}</span>
            </li>
          </ul>
        </div>
        <p class="legend-version m-0 mt-4 text-center text-[10px] opacity-35">{{ translation.getText('legend', 'site_version', 'Site version') }}: v{{ version }}</p>
      </div>
    </section>
  </div>
</div>
